import { render, staticRenderFns } from "./rewardsAll.vue?vue&type=template&id=27c4cfe6&scoped=true"
import script from "./rewardsAll.vue?vue&type=script&lang=js"
export * from "./rewardsAll.vue?vue&type=script&lang=js"
import style0 from "./rewardsAll.vue?vue&type=style&index=0&id=27c4cfe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4cfe6",
  null
  
)

export default component.exports